// removed by extract-text-webpack-plugin
module.exports = {" _key":"dojo2-stateful-example/App","controlContainer":"xO8ZRuH9","counterButton":"_2TaQvVzU","counter":"_3TieXBPA","label":"_22IFvjlT"};


//////////////////
// WEBPACK FOOTER
// ./src/App.m.css
// module id = ./src/App.m.css
// module chunks = main